import { render, staticRenderFns } from "./add-prod.vue?vue&type=template&id=e263dbf6&scoped=true"
import script from "./add-prod.vue?vue&type=script&lang=js"
export * from "./add-prod.vue?vue&type=script&lang=js"
import style0 from "./add-prod.vue?vue&type=style&index=0&id=e263dbf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e263dbf6",
  null
  
)

export default component.exports